/* eslint-disable array-callback-return */
import React, { useEffect, useState, useRef, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

import TopInput from "./TopInput";
import {
  canteenActions,
  locationActions
} from "../../../redux/actions";
import { helperFunction } from "../../../constant/helper";
import UserList from "./UserList";
import {
  advancedFilterWorker,
  tableSkeleton
} from "../../../constant/helper/helper";
import { tableHeaderData } from "./canteenStaticData";
import { types } from "../../../redux/type";
import Card from "../../../component/card/Card";
import isEmpty from "../../../validation/isEmpty";
import Starter from "../../../component/Starter";
import TableHeader from "../../../component/tableHeader/TableHeader";
import useSortableData from "../../../customHooks/sortingHooks";

const initialState = {
  Filter: "",
  locationId: "",
  date: ""
};

const DailyCanteen = () => {
  const componentRef = useRef();
  const loginType = localStorage.loginType;
  const dispatch = useDispatch();
  const [dailyArray, setDailyArray] = useState([]);
  const [values, setValues] = useState(initialState);
  const [allLocations, setAllLocations] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);

  const { locationError, locations } = useSelector(
    (state) => state.location
  );
  const { currentUser } = useSelector((state) => state.auth);

  const {
    date,
    locationId,
    canteenError,
    dailyCanteens,
    canteenLoading,
    selectedInputs
  } = useSelector((state) => state.canteen);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setValues({
      ...values,
      [name]: value
    });
  };

  useEffect(() => {
    setValues({
      ...values,
      date,
      locationId
    });
  }, [date, locationId]);

  useEffect(() => {
    if (!isEmpty(dailyCanteens)) {
      setDailyArray(dailyCanteens);
    }
  }, [dailyCanteens]);

  useEffect(() => {
    if (locationError) {
      helperFunction.toastHelper("error", locationError);
    }
    if (canteenError) {
      helperFunction.toastHelper("error", canteenError);
    }
  }, [locationError, canteenError]);

  useEffect(() => {
    if (locations !== null) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  useEffect(() => {
    if (selectedInputs !== null) {
      setSelectedCategory(selectedInputs);
    } else {
      setSelectedCategory([]);
    }
  }, [selectedInputs]);

  useEffect(() => {
    dispatch(locationActions.clearLocationErrors());
    dispatch(locationActions.clearLocationResult());
    dispatch(canteenActions.clearCanteenErrors());
    dispatch(canteenActions.clearCanteenResult());
    return () => {
      dispatch(locationActions.clearLocationErrors());
      dispatch(locationActions.clearLocationResult());
      dispatch(canteenActions.clearCanteenErrors());
      dispatch(canteenActions.clearCanteenResult());
    };
  }, []);

  const defaultValueFunction = () => {
    const selectedChoice = {};
    selectedCategory.map((i) => {
      selectedChoice[i.value] = 1;
    });

    const newObject = {
      Date: 1,
      workerId: 1,
      lunchTime: 1,
      dinnerTime: 1,
      breakFastTime: 1
    };
    Object.keys(selectedChoice).forEach(function (key) {
      newObject[key] = selectedChoice[key];
    });

    return JSON.stringify(newObject);
  };

  // fetch daily canteen
  const fetchDailyCanteen = (e) => {
    e.preventDefault();
    const dataToGetDailyCanteen = defaultValueFunction();
    dispatch(canteenActions.setCanteenLoading(true));
    dispatch(canteenActions.clearCanteenErrors());
    dispatch(canteenActions.clearCanteenResult());
    const empty = isEmpty(loginType);
    if (empty) {
      const errorData = {
        data: { message: "PLEASE LOGOUT AND LOGIN AGAIN" },
        status: 401
      };
      dispatch({
        type: types.CanteenTypes.CANTEEN_GET_ERRORS,
        payload: errorData
      });
    } else {
      dispatch(
        canteenActions.getDailyCanteen(
          values.date,
          values.locationId,
          loginType,
          dataToGetDailyCanteen,
          selectedCategory
        )
      );
    }
  };

  // show user list
  const showUserList = (sortedArray) => {
    if (canteenLoading) {
      return <tr>{tableSkeleton(7 + selectedCategory.length)}</tr>;
    } else if (sortedArray === null) {
      return (
        <tr style={{ top: "50%", left: "50%", position: "fixed" }}>
          <td>
            <span className="">Please Select Locations and Date</span>
          </td>
        </tr>
      );
    } else if (sortedArray.length === 0) {
      return (
        <tr
          style={{
            top: "50%",
            left: "50%",
            position: "absolute",
            transform: "translate(-50%, -50%)"
          }}
        >
          <td>
            <span className="">
              No Record Found for date {values.date}
            </span>
          </td>
        </tr>
      );
    } else if (!isEmpty(sortedArray) && sortedArray.length > 0) {
      const filteredUser = advancedFilterWorker(
        sortedArray,
        values.Filter,
        "fullNameAndId"
      );

      return filteredUser.map((filterDailyCanteen, index) => (
        <UserList
          key={index}
          values={values}
          parentIndex={index}
          dailyCanteen={filterDailyCanteen}
        />
      ));
    }
  };

  const { items, requestSort, sortConfig } = useSortableData(
    dailyArray
  );

  const renderDynamicHeader = (selectedValues) => {
    return selectedValues?.map(
      (headerDynamic, dynamicHeaderIndex) => {
        return (
          <th key={dynamicHeaderIndex}>{headerDynamic.label}</th>
        );
      }
    );
  };

  // return main render
  return (
    <Starter
      topBarTitle="Daily Canteen"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Canteen Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Canteen</a>
          </li>
          <li className="breadcrumb-item active">Daily Canteen</li>
        </Fragment>
      }
    >
      <Card>
        <TopInput
          values={values}
          currentUser={currentUser}
          loading={canteenLoading}
          onChange={handleInputChange}
          onSubmit={fetchDailyCanteen}
          selectedCategory={selectedCategory}
          handleSelectCategories={(input) =>
            setSelectedCategory(input)
          }
          allLocations={
            typeof allLocations !== "undefined" &&
            allLocations.length > 0
              ? allLocations
              : []
          }
        />
        <div
          className="table-responsive"
          ref={componentRef}
          style={{
            height: "700px",
            overflow: "auto",
            position: "relative"
          }}
        >
          <table
            className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
            id="products-datatable"
          >
            <thead className="thead-light">
              <tr>
                <th style={{ width: "20px" }}>#</th>
                <th style={{ width: "80px" }}>Date</th>
                <TableHeader
                  tableHeaderData={tableHeaderData}
                  requestSort={requestSort}
                  sortConfig={sortConfig}
                />
                <th className="text-center">Break Fast</th>
                <th className="text-center">Lunch</th>
                <th className="text-center">Dinner</th>
                {renderDynamicHeader(selectedCategory)}
              </tr>
            </thead>
            <tbody>{showUserList(items)}</tbody>
          </table>
        </div>
      </Card>
      <div className="row mt-3">
        <div className="col-sm-1"></div>
        <div className="col-sm-4"></div>
        <div className="col-2">
          <ReactHTMLTableToExcel
            sheet="Sheet"
            buttonText="Export excel"
            table="products-datatable"
            filename={`${values.date}`}
            className="btn btn-dark btn-block"
          />
        </div>
        <div className="col-sm-1"></div>
        <div className="col-sm-4"></div>
      </div>
    </Starter>
  );
};

export default DailyCanteen;
